import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Heading1(props: ComponentPropsWithoutRef<'h1'>) {
  const { children, ...rest } = props;

  return (
    <Typography
      as="h1"
      variant="display6"
      weight="medium"
      className="text-grayscale600"
      {...rest}
    >
      {children}
    </Typography>
  );
}
